import { Component, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';


import { CampaignIncentivesService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import type { TCampaignIncentive, TPopoverMenuItem } from '@shared/models';

@Component({
    'selector': 'app-campaignIncentive',
    'templateUrl': './campaignIncentive.page.html',
    'styleUrls': ['./campaignIncentive.page.scss'],
    'standalone': true,
    'imports': [CommonModule, FormsModule, IonicModule],
    'schemas': [CUSTOM_ELEMENTS_SCHEMA]
})
export class CampaignIncentivePage extends ViewBasePage implements OnInit, OnDestroy {
    public isDebugMode = false;
    public incentive: TCampaignIncentive;
    private uid: string | null;
    public submitted = false;
    public error = {};

    constructor(private campaignIncentivesService: CampaignIncentivesService, private activatedRoute: ActivatedRoute,
        injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_SETTINGS_CAMPAIGN_INCENTIVE);
    }

    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();

        try {
            this.incentive = this.campaignIncentivesService.getNullable();
            this.uid = this.activatedRoute.snapshot.paramMap.get('uid');
            if (this.uid) {
                this.incentive = await this.campaignIncentivesService.getByUid(this.uid);
            } else {
                this.incentive.sequenceNumber = await this.campaignIncentivesService.getNextSequenceNumber();
            }
            this.initMoreMenu();
        } catch (err) {
            throw new Error('Error in incentive.ngOnInit() ');
        }
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    public initMoreMenu(): void {
        this.pushPopoverMenuItem('Example 1');
        this.pushPopoverMenuItem('Example 2');
        this.pushPopoverMenuItem('Example 3');
        this.pushPopoverMenuItem('Show Tour', 'show-campaign-incentive-tour');

        this.moreMenuItemClick((menuItem: TPopoverMenuItem) => {
            switch (menuItem.name) {
                case 'Example 1':
                    this.example1();
                    break;

                case 'Example 2':
                    this.example2();
                    break;

                case 'Example 3':
                    this.example3();
                    break;
            }
        });
    }

    public callButtonText(showCallButton: boolean) {
        const text = (showCallButton) ? 'Call button will be displayed.' : 'Call button will not be displayed';
        return text;
    }

    private example1() {
        this.incentive.title = 'Free Car Wash';
        this.incentive.line1 = 'Especially For [CustomerName]';
        this.incentive.line2 = 'Normal Price: $20.00';
        this.incentive.line3 = 'Discount: $20.00';
        this.incentive.line4 = 'Your Price: $0.00';
        this.incentive.line5 = 'Valid Dates: Jan 1 - Jan 30';
        this.incentive.line6 = 'Incentive Code: CC-123';
        this.incentive.line7 = 'This is a great deal.  Hurry on down!';
        this.incentive.buttonText = 'Click To Make An Appointment';
        this.incentive.showCallButton = true;
    }

    private example2() {
        this.incentive.title = 'Tire Rotation';
        this.incentive.line1 = 'For [CustomerName]';
        this.incentive.line2 = 'Normal Price: $40.00';
        this.incentive.line3 = '';
        this.incentive.line4 = 'Your Price: $32.00';
        this.incentive.line5 = 'Valid Dates: Feb 1 - Feb 28';
        this.incentive.line6 = 'Incentive Code: CC-456';
        this.incentive.line7 = '';
        this.incentive.buttonText = 'Click To Make An Appointment';
        this.incentive.showCallButton = true;
    }

    private example3() {
        this.incentive.title = '23 Point Inspection';
        this.incentive.line1 = 'Especially For [CustomerName]';
        this.incentive.line2 = 'Normal Price: $49.00';
        this.incentive.line3 = '';
        this.incentive.line4 = 'Your Price: $9.99';
        this.incentive.line5 = 'Valid Dates: Mar 1 - Mar 30';
        this.incentive.line6 = 'Incentive Code: CC-789';
        this.incentive.line7 = 'While Supplies Last';
        this.incentive.buttonText = 'Click To Check Inventory';
        this.incentive.showCallButton = true;
    }

    public async onSaveClick(form: NgForm) {
        this.submitted = true;
        if (!form.valid) {
            return;
        }
        try {
            await this.uxHelperService.showSpinner('Saving.');
            if (!this.uid) {
                await this.campaignIncentivesService.add(this.incentive);
            } else {
                await this.campaignIncentivesService.update(this.incentive);
            }
            this.uxHelperService.showToast('Saved.');
            this.router.navigateByUrl('/marketing/campaignIncentives');
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error:', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
        }
    }
}
